import type {
  MoneyServerType,
  MoneyType,
  RevenueTierServerType,
  RevenueTierType,
} from '@/lib/types/common.types'

export const normalizeMoney = (moneyObj: MoneyServerType): MoneyType => ({
  amount: Number(moneyObj.amount),
  currency: moneyObj.currency,
})

export const normalizeRevenueTier = (tier: RevenueTierServerType): RevenueTierType => ({
  id: tier.id,
  name: tier.name,
  revenueShare: tier.revenue_share,
  instagramRevenueShare: tier.instagram_revenue_share,
  clientId: tier.client_id,
  validatesUsers: tier.validates_users,
  createdAt: tier.created_at,
  updatedAt: tier.updated_at,
})

export const normalizeRevenueTiers = (revenueTiers: RevenueTierServerType[]): RevenueTierType[] => {
  return revenueTiers.map(normalizeRevenueTier)
}

export const serializeMoney = (moneyObj: MoneyType): MoneyServerType => ({
  amount: moneyObj.amount.toString(),
  currency: moneyObj.currency,
})
